<template>
  <div class="animate-panel"  data-child="hpanel" data-effect="fadeInDown">
    <div class="hpanel no-margins" >
      <template v-if="companies.length !== 0">
        <div class="panel-body no-padding ">
          <table style="width: 100%;margin-top: 5px">
            <tr style="height: 25px">
              <template v-if="context.name === 'expertResult'">

                <template v-if="context.workflowId === 1">
                  <th class="col-md-5 col-xs-3">
                    <div class="row">
                      <div class="col-xs-7 col-md-7">
                        <span role="button" @click="changeSort('affiliation')">Company <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                      </div>
                      <div class="col-xs-5 col-md-5 text-center">
                        <div class="row">
                          <span role="button" @click="changeSort('country')">Country <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                        </div>
                      </div>
                    </div>
                  </th>

                </template>
                <template v-else>
                  <th class="col-md-5 col-xs-3">
                    <div class="row">
                      <div class="col-xs-5 col-md-5 text-center">
                        <div class="row">
                          <span role="button" @click="changeSort('country')">Country <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                        </div>
                      </div>
                      <div class="col-xs-7 col-md-7">
                        <div class="row">
                          <span role="button" @click="changeSort('affiliation')">Company <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                        </div>
                      </div>
                    </div>
                  </th>
                </template>

                <th class="col-md-2 col-xs-3"><span>Source</span></th>
                <th class="hidden"><span role="button" @click="changeSort('score')">Score <i style="padding-left: 15px" class="fa fa-sort"></i></span></th>
                <th class="col-md-2 col-xs-2 text-center"><span>Action</span></th>
              </template>
              <template v-else>
                <th class="visible-md visible-lg visible-xl col-md-2 col-lg-2 col-xl-1 text-center">

                  <div class="btn-group">
                    <button type="button" class="btn btn-info btn-outline btn-xs" style="padding-left: 10px;padding-right: 0;" @click="allChecked = !allChecked">
                      <div class="checkbox checkbox-info" style="margin: 2px 0 0 0;">
                        <input type="checkbox" :checked="allChecked">
                        <label></label>
                      </div>
                    </button>
                    <button type="button" class="btn btn-info btn-outline btn-xs dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="padding-top: 4px;padding-bottom: 4px;">
                      <i class="fa fa-caret-down"></i>
                    </button>
                    <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu1" style="float: right;z-index: 1005;" >
                      <li v-if="allChecked === false"><a role="button" @click="allChecked = true"><i class="fa fa-check-square-o text-success"></i> Select All</a></li>
                      <li v-if="allChecked === true"><a role="button" @click="allChecked = false"><i class="fa fa-square-o text-danger"></i> Unselect All</a></li>
                      <li  class="dropdown-submenu-copyto dropdown-submenu">
                        <a tabindex="-1" class="copyToCompanyItem" href="#"><i class="fa fa-copy text-warning"></i> Copy Selected to <span class="fa fa-caret-down"></span></a>
                        <ul id ="copyCompanyToListUl" class="dropdown-menu copyCompanyToListUl">
                          <template v-if="context.projectsLists && context.projectsLists.length">
                            <li>
                              <span class="copyToProjectTitle m-b"><u>Select SubProject:</u></span>
                              <span class="" style="float: right">
                                <button class="btn btn-xs btn-info" @click="fullScreen"><i id="iconCopyCompanyFullScreen" class="glyphicon glyphicon-resize-full"></i></button>
                              </span>
                            </li>
                            <li v-for="(project, key) in context.projectsLists" v-if="project.lists && project.lists.length"  :key="key">
                              <div style="font-size: 12px; padding: 3px 20px">
                                <span class="text-info copyToProjectLi">{{truncateString(project.name,20)}}</span>
                                <ul>
                                  <li v-for="(list, listKey) in project.lists"   :key="'list-'+listKey" :id="'list-id-'+list.id" class="copyToListLi" :title="'Subproject '+list.title">
                                    <a role="button" @click="copyAllSelected(list.id)"><i class=" far fa-circle text-info"></i> {{truncateString(list.title,18)}}</a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </template>
                          <template v-else>
                            <li style="padding: 15px">Project list empty</li>
                          </template>
                        </ul>
                      </li>
                      <li><a role="button" @click="deleteAllSelected"><i class="fa fa-trash text-danger"></i> Delete Selected</a></li>
                      <li class="divider"></li>
                      <li><a role="button" @click="context.exportCsv('companies')"><i class="fa fa-file-excel-o text-info"></i> Export All Csv</a></li>
                    </ul>
                  </div>
                </th>
                <th class="col-xs-6 col-md-5 col-lg-5 col-xl-6">
                  <table class="table" style="width: 100%">
                    <td class="col-xs-5 col-md-5 text-center" style="vertical-align: middle">
                      <span role="button" @click="changeSort('country')">Country <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                    </td>
                    <td class="col-xs-7 col-md-7" style="vertical-align: middle">
                      <span role="button" @click="changeSort('affiliation')">Company <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                    </td>
                  </table>
                </th>
                <th class="col-xs-4 col-md-3 col-lg-3 col-xl-4"><span>Source</span></th>
                <th class="col-xs-2 col-md-2 col-lg-2 col-xl-1 text-center"><span>Action</span></th>
              </template>

            </tr>
          </table>
          <div v-if="companies.length !== 0" >
            <div v-for="(company, key) in companies" v-if="company && key < context.nbItemsDisplay" :key="key + '-' + company.authorID" class="clearfix ">
              <company-top v-model="companies[key]" class="" :context="context" :key="key + '-' + company.authorID + company.checked" @companyChecked="companyChecked"/>
              <div class="col-xs-12 collapse" :id="'collapse-'+ company.authorID" style="padding: 20px" >
                <documents-company v-model="companies[key].docs" :author="company"
                                   :pubDateSelected="context.pubDateSelected" :context="context"/>
              </div>
            </div>
            <div class="text-center" style="padding: 25px">
              <button class="btn btn-primary btn-xs" :class="companies.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayMore">Display more</button>
              <button class="btn btn-primary btn-xs" :class="companies.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayAll">Display all</button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<style scoped>

  .dropdown-submenu {
    position: relative;
  }

  .dropdown-submenu .dropdown-menu {
    top: 0;
    left: 165px;
    margin-top: -1px;
    overflow-y: scroll;
    max-height: 200px;
    width: 250px;
    text-transform: capitalize;
  }

  .copyToListLi {
    margin: 5px;
    overflow-y: hidden;
  }

  .copyToProjectLi {
    background: #f9f9f9;
    width: 300px;
    padding: 2px 5px;
    display: table-cell;
    overflow-y: hidden;
  }

  #copyCompanyToListUl.fullScreen {
    display: block;
    z-index: 1005;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: white;
    padding: 25px;
    max-height: inherit;
  }

  #copyCompanyToListUl.fullScreen .copyToProjectLi {
    width: 100%;
    display: block;
    padding: 10px 20px;
    font-size: medium;
  }

  #copyCompanyToListUl.fullScreen .copyToListLi {
    width: 100%;
    display: block;
    padding: 5px 10px;
    font-size: medium;
  }

  .copyToProjectTitle {
    display: none;
  }

  #copyCompanyToListUl.fullScreen .copyToProjectTitle {
    display: contents;
    font-size: x-large;
  }
</style>
<script>
import CompanyTop from '../documents/CompanyTop'
import DocumentsCompany from '../documents/DocumentsCompany'

export default {
  components: {
    DocumentsCompany,
    CompanyTop
  },
  props: ['context', 'value', 'listType', 'changeSort'],
  name: 'ListCompaniesSelected',
  watch: {
    value: function (val) {
      this.companies = val
    },
    allChecked: function (val) {
      this.companies.forEach((company) => {
        company.checked = val
      })
      this.companies = Object.assign([], this.companies)
    }
  },
  data () {
    return {
      companies: null,
      allChecked: false
    }
  },
  methods: {
    companyChecked: function (company) {
      let index = this.companies.indexOf(company)

      if (typeof index !== 'undefined') {
        this.companies[index].checked = true
      }
    },
    deleteAllSelected: function () {
      this.companies.forEach((company) => {
        if (company.checked === true) {
          this.context.removeCompany(company)
        }
      })
    },
    copyAllSelected: function (copyToListId) {
      this.companies.forEach((company) => {
        if (company.checked === true) {
          this.context.copyToList(company, copyToListId)
        }
      })
      this.removeFullScreen()
      $('.dropdown-submenu-copyto a.copyToItem').next('ul').hide()
    },
    truncateString: function (str, num) {
      if (typeof str !== 'undefined' && str.length > num) {
        return str.slice(0, num) + ' ...'
      } else {
        return str
      }
    },
    fullScreen: function (e) {
      let list = $('.dropdown-menu.copyCompanyToListUl')
      let iconFullScreen = $('#iconCopyCompanyFullScreen')

      if (list.hasClass('fullScreen')) {
        list.removeClass('fullScreen')
        iconFullScreen.removeClass('glyphicon-resize-small')
        iconFullScreen.addClass('glyphicon-resize-full')
      } else {
        list.addClass('fullScreen')
        iconFullScreen.addClass('glyphicon-resize-small')
        iconFullScreen.removeClass('glyphicon-resize-full')
      }
      e.stopPropagation()
      e.preventDefault()
    },
    removeFullScreen: function () {
      let list = $('.dropdown-menu.copyCompanyToListUl')
      let iconFullScreen = $('#iconCopyCompanyFullScreen')

      if (list.hasClass('fullScreen')) {
        list.removeClass('fullScreen')
        iconFullScreen.removeClass('glyphicon-resize-small')
        iconFullScreen.addClass('glyphicon-resize-full')
      }
    }
  },
  mounted () {
    $(document).on('click', '.filter .dropdown-menu', function (e) {
      e.stopPropagation()
    })

    $('.dropdown-submenu-copyto a.copyToCompanyItem').on('mouseover', function (e) {
      $(this).children('span').toggleClass('fa-caret-down').toggleClass('fa-caret-right')
      $(this).next('ul').show()
      e.stopPropagation()
      e.preventDefault()
    })

    $('.dropdown-submenu-copyto').on('mouseleave', (e) => {
      this.removeFullScreen()
      $(this).find('a.copyToCompanyItem').children('span').removeClass('fa-caret-right').addClass('fa-caret-down')
      $('.dropdown-submenu-copyto a.copyToCompanyItem').next('ul').hide()
      e.stopPropagation()
      e.preventDefault()
    })

    $(document).keyup((e) => {
      if (e.key === 'Escape') {
        this.removeFullScreen()
      }
    })
  },
  beforeMount () {
    this.companies = this.value

    this.companies.forEach((company) => {
      company.checked = false
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListCompanies/ListCompaniesSelected.vue